import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Modal, ModalHeader, ModalBody, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Translate, { t } from '../../common/Translate';
import { useDeleteRecord } from '../../../hooks/useCalendar/useRecordBlocs/useDeleteRecord';

export const DeleteModal = ({ isOpen, toggle, recordId }) => {
  const { cancelAppointment, isError, error } = useDeleteRecord({ recordId, toggle });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle} className="model-title">
        <FontAwesomeIcon icon={faTrashAlt} className="calendar-icon" />
        {t('delete_appointement')}
      </ModalHeader>
      <ModalBody>
        <Row className="mb-4">
          <Col xs="12">
            <Label className="mb-2 text-primary text-left" for="meetingDate">
              <Translate code="confirm_delete_appointment" />
            </Label>
            {isError && (
              <p className="ml-2 text-danger">
                <Translate code={error} />
              </p>
            )}
          </Col>
        </Row>
        <button type="button" className="btn btn-block btn-1" onClick={cancelAppointment}>
          {t('validate')}
        </button>
      </ModalBody>
    </Modal>
  );
};

DeleteModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  recordId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
